<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
          class="full-width"
          ><div slot="header">
            <strong>View Access Rules</strong>
            <!-- <eb-button
              style="color:white; font-weight:bold;float: right;"
              text="Back"
              @click="e => $emit('created', e)"
            ></eb-button> -->
          </div>
          <form>
            <b-row>
              <b-col md="12">
                <div class="form-group">
                  <label for="planName">Name </label>
                  <b-form-input
                    class=""
                    id="planName"
                    disabled
                    inputType="text"
                    v-model="details.Name"
                  />
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <div class="form-group">
                  <label for="keys">keys </label>
                  <b-form-input
                    id="keys"
                    disabled
                    class=""
                    inputType="text"
                    v-model="details.Keys"
                  />
                </div>
              </b-col>
            </b-row>
          </form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AccessruleDetails from "@/components/MasterSetup/accessrules/AccessruleDetails";
import ebButton from "@/components/FormElements/Button";
export default {
  name: "viewaccessrule",
  components: {
    ebButton,
    AccessruleDetails,
  },
  data: () => {
    return {};
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  computed: {
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
.myDIV:hover + .hide {
  display: block;
  position: absolute;
}
.hide {
  display: none;
  font-size: 11px;
}
</style>
